import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { dashboardQueries } from '../../queries/dashboard.queries';

import { useFiltersStore, useQueriesWithGlobal } from '@data-access';

export function useSynthesis() {
  const page =
    useFiltersStore.use['dashboardSynthesis']().pagination.pageIndex + 1;
  const sorting = useFiltersStore.use['dashboardSynthesis']().sorting;
  const filters = useFiltersStore.use['dashboardSynthesis']().filters;
  const queries = useQueriesWithGlobal(dashboardQueries);

  const query = useQuery({
    ...queries.synthesis({ page, sorting, filters }),
    placeholderData: keepPreviousData,
  });

  return query;
}

export default useSynthesis;
